module.exports = __webpack_public_path__ + "img/txt.699ee5e5.png";